import {Component, Input, OnInit} from '@angular/core';
import {Action} from '@app/shared/components/action/action.model';

@Component({
  selector: 'app-card-title-toolbar',
  templateUrl: './card-title-toolbar.component.html',
  styleUrls: ['./card-title-toolbar.component.scss']
})
export class CardTitleToolbarComponent implements OnInit {

  @Input() title: string;
  @Input() icon: string;
  @Input() iconFa: string;
  @Input() actions: Action[];

  constructor() {
  }

  ngOnInit() {
  }

}
